import { Controller } from "@hotwired/stimulus"
import { activationTokenFromHash, locationWithoutHash } from "../lib/membership_activation.mjs"

export default class extends Controller {
  static targets = ["status", "submit", "token"]

  connect() {
    const fragmentToken = activationTokenFromHash(window.location.hash)
    if (fragmentToken) this.tokenTarget.value = fragmentToken

    if (window.location.hash) {
      window.history.replaceState(window.history.state, "", locationWithoutHash(window.location))
    }

    if (this.tokenTarget.value) {
      this.submitTarget.disabled = false
      this.statusTarget.hidden = true
    } else {
      this.statusTarget.textContent = "This Kova account activation link is invalid or incomplete."
    }
  }
}
